import { render, staticRenderFns } from "./ShareRecording.vue?vue&type=template&id=366e81bc&scoped=true"
import script from "./ShareRecording.vue?vue&type=script&lang=js"
export * from "./ShareRecording.vue?vue&type=script&lang=js"
import style0 from "./ShareRecording.vue?vue&type=style&index=0&id=366e81bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e81bc",
  null
  
)

export default component.exports